import React, { useState } from "react";
import "./dynamic-table.css";
import { ArrowUpward, ArrowDownward, UnfoldMore } from "@mui/icons-material";
import Pagination from "./Pagination";

const DynamicTable = ({
    columns = [],
    data = [],
    currentPage,
    totalPages,
    itemsPerPage,
    onItemsPerPageChange,
    totalItems,
    onPageChange,
    onSort,
    role,
    rowKey = "_id",
    emptyMessage = "No data found"
}) => {

    return (
        <>
            <div className="table-responsive tbl-fixed-header tbl-main">
                <table className="table table-col-freeze">

                    <thead>
                        <tr>
                            {columns.map((col, i) => (
                                col.visible !== false && (
                                    <th
                                        key={i}
                                        className={col.className || ""}
                                        style={{
                                            cursor: col.sortable !== false ? "pointer" : "default",
                                            userSelect: "none",
                                        }}
                                    >
                                        <div style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}>
                                            <span>{col.label}</span>
                                        </div>
                                    </th>
                                )
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <tr key={row[rowKey] || index}>
                                    {columns.map((col, colIndex) => (
                                        col.visible !== false && (
                                            <td key={colIndex} className={col.className || ""}>
                                                {col.render
                                                    ? col.render(row, index)
                                                    : row[col.field]
                                                }
                                            </td>
                                        )
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="text-center">
                                    {emptyMessage}
                                </td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalRecords={totalItems}
                perPage={itemsPerPage}
                onPageChange={onPageChange}
            />
        </>
    );
};

export default DynamicTable;